<template>
  <div class="container signing">
    <navBar/>
    <div class="mt-5 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
        <!--<img src="@/assets/images/document/sign-success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">-->

        <h1>Reanudando proceso</h1>
        <p class="mb-10 mt-3">Hemos detectado una sesión activa. Estamos sincronizando tu progreso, por favor no cierres la ventana: </p>
        <div class="timer">
          <div class="time-timer">
            <span class="text-primary">Sincronizando: </span>
            <span class="minute">{{ formattedMinute }}</span>:
            <span class="second">{{ formattedSecond }}</span>
          </div>
          <div>
            <vs-progress :percent="tempW" color="primary"></vs-progress>
          </div>
        </div>

        <transition name="fade">
          <div :key="index" >
            <h2 class="sm:mx-0 mt-5 mb-10 text-4xl d-theme-heading-color">
              <feather-icon :icon="text.icon" svgClasses="p-rela top-2 h-8 w-8  text-primary" />
              {{ text.text }}
            </h2>
          </div>
        </transition>

      </div>
    </div>

  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";

export default {
  components: {
    navBar,
  },
  data() {
    return {
      types: ['default'],
      index: 0,
      texts: [
        {icon: 'SearchIcon', text: 'Detectando sesión activa...'},
        {icon: 'RefreshCwIcon', text: 'Sincronizando progreso con el servidor...'},
        {icon: 'DatabaseIcon', text: 'Recuperando datos de validación...'},
        {icon: 'ShieldIcon', text: 'Verificando estatus ante el proveedor...'},
        {icon: 'CheckCircleIcon', text: 'Casi listo para continuar...'},
      ],
      m: 0, // Minutos
      s: 15, // Segundos (Tiempo de sincronización más corto)
      tempW: 0, // Ancho de la barra de progreso
      clearInter: null, // Referencia al intervalo del temporizador
      textInterval: null, // Referencia al intervalo de los textos
    };
  },
  computed: {
    text() {
      return this.texts[this.index];
    },
    formattedMinute() {
      return this.m < 10 ? `0${this.m}` : this.m;
    },
    formattedSecond() {
      return this.s < 10 ? `0${this.s}` : this.s;
    }
  },
  mounted() {
    this.initTimer();
    this.textInterval = setInterval(() => {
      if (this.index < this.texts.length - 1) {
        this.index++;
      }
    }, 3000);
  },
  methods: {
    initTimer() {
      this.tempW = 0; // Inicializa el ancho de la barra de progreso
      this.clearInter = setInterval(this.timerCal, 1000);
    },
    timerCal() {
      if (this.s === 0) {
        if (this.m === 0) {
          clearInterval(this.clearInter); // Detiene el temporizador si el tiempo se agota
          clearInterval(this.textInterval); // Detiene el intervalo de los textos
        } else {
          this.m--;
          this.s = 59;
        }
      } else {
        this.s--;
      }
      this.tempW = ((15 - (this.m * 15 + this.s)) * (100 / 15)); 
    },
  },
  beforeDestroy() {
    clearInterval(this.clearInter);
    clearInterval(this.textInterval); // Limpia ambos intervalos
  },
}
</script>



<style scoped lang="scss">
.vs-con-loading__container .con-vs-loading{
  background: #fcfcfc!important;
}
h1{
  font-size: 32px;
}

.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background: #fcfcfc!important;
  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    background: #fcfcfc!important;
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }
    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}
.p-rela{
  position: relative!important;
}
.top-2{
  top:2px!important;
}
.fade-leave-active {
  transition: opacity .1s ease-in;
}
.fade-enter-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0.0;
}
.fade-leave, .fade-enter-to {
  opacity: 1.0;
}
.timer{
  width: 70%;
}
.progress {
  background-color: #ddd;
  height: 13px;
  overflow: hidden;

  .bar {
    background-color: #315abb; // Esta propiedad sobreescribe la anterior del mismo nombre
    width: 0%;
    height: inherit;
    background-repeat: repeat-x;
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 15px 15px;
    transition: width 0.6s ease 0s;

    // Unificación de las animaciones
    -moz-animation: 2s linear 0s normal none infinite running progress-bar-stripes;
    animation: 2s linear 0s normal none infinite running progress-bar-stripes;
  }
}
p{
  max-width: 750px;
  font-size: 18px;
}
.timer{
  margin-bottom: 35px;
}
.time-timer{
  span{
    font-size: 20px;
  }
}
</style>
